import { render, staticRenderFns } from "./manuscripts.vue?vue&type=template&id=119eae40&scoped=true&"
import script from "./manuscripts.vue?vue&type=script&lang=js&"
export * from "./manuscripts.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./manuscripts.vue?vue&type=style&index=1&id=119eae40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119eae40",
  null
  
)

export default component.exports